"use client";
import { React, useState, useEffect } from "react";
import { RiMenu2Fill } from "@remixicon/react";
import { useNavigate, Link, useLocation } from "react-router-dom";

const NavigationBar = ({ activeItem = "app" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [actvieTab, setActiveTab] = useState(activeItem);

  const navItems = [
    { id: "app", label: "Trang chủ", href: "/app" },
    { id: "topics", label: "Thảo luận", href: "/app/topics" },
    { id: "documents", label: "Tài liệu", href: "/app/documents" },
    {
      id: "review-channel",
      label: "Danh sách các kênh youtube",
      href: "/app/review-channel",
    },
    { id: "donate", label: "Ủng hộ", href: "/app/donate" },
    { id: "policy-privacy", label: "Chính sách", href: "/privacy-policy" },
    { id: "studio", label: "Studio", href: "/app/studio" },
    // { id: "termsofservices", label: "Terms of service", href: '/terms-of-service' },
  ];

  useEffect(() => {
    navItems.forEach((item, index) => {
      if (location.pathname === item.href) {
        setActiveTab(item.id);
        return;
      }
      if (location.pathname.includes(item.href)) {
        setActiveTab(item.id);
        return;
      }
    });
  }, [location]);

  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="flex items-center justify-between p-4">
      {/* Hamburger Button for Mobile */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="md:hidden p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-rose-500"
      >
        <RiMenu2Fill className="w-6 h-6 text-gray-700" />
      </button>

      {/* Navigation List */}
      <ul
        className={`flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4 absolute md:static left-0 top-20 w-full md:w-auto bg-white md:bg-transparent shadow-md md:shadow-none p-4 md:p-0 transition-all ${
          isOpen ? "block" : "hidden md:flex"
        }`}
        style={{ zIndex: "10" }}
      >
        {navItems.map((item) => (
          <li key={item.id}>
            <Link
              to={item.href}
              className={`block px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                actvieTab === item.id
                  ? "text-rose-700 bg-rose-100"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
              aria-current={actvieTab === item.id ? "page" : undefined}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavigationBar;
